<template>
  <div class="search-main" :style="{ background }">
    <div class="search-content">
      <slot name="left"></slot>
      <input
        type="text"
        class="search-input"
        :placeholder="placeholder"
        v-model="searchValue"
        @keydown.13="search"
        growing-track='true' >
      <slot name="right"></slot>
    </div>
    <div class="search-btn" @click="search">
      <i class="iconfont iconsousuo"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Search',
  props: {
    value: '',
    background: {
      type: String,
      default: '#fff'
    },
    placeholder: {
      type: String,
      default: '请输入'
    }
  },
  data() {
    return {
      searchValue: ''
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        this.searchValue = val;
      }
    },
    // searchValue: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     this.value = val;
    //   }
    // }
  },
  methods: {
    search() {
      this.$emit('search', this.searchValue);
    }
  },
}
</script>
<style lang="scss" scoped>
.search-main {
  width: 900px;
  height: 50px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  margin-bottom: 6px !important;
  -webkit-box-shadow: 0px 1px 8px 0px rgba(0, 28, 80, 0.08);
  box-shadow: 0px 1px 8px 0px rgba(0, 28, 80, 0.08);
  * {
    box-sizing: border-box;
  }
  .search-content {
    width: 100%;
    height: 100%;
    flex: 1;
    padding-left: 20px;
    border-radius: 4px 0 0 4px;
    display: flex;
    align-items: center;
    .search-input {
      width: 100%;
      height: 100%;
      flex: 1;
      background: transparent;
      padding: 0 16px;
      font-size: 14px;
      color: rgba(64, 64, 64, 1);
    }
  }
  .search-btn {
    width: 82px;
    height: 100%;
    background: rgba(255, 102, 68, 1);
    text-align: center;
    line-height: 50px;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    &:hover {
      background: rgba(255, 102, 68, .8);
    }
    .iconfont {
      color: #fff;
      font-size: 20px;
      font-weight: 600;
    }
  }
}
</style>
